export const HSE_URL = 'https://hse.nedgia.es'
